/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyFiltersTagResponseDTO
 */
export interface SurveyFiltersTagResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveyFiltersTagResponseDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyFiltersTagResponseDTO
     */
    value: string;
}

export function SurveyFiltersTagResponseDTOFromJSON(json: any): SurveyFiltersTagResponseDTO {
    return SurveyFiltersTagResponseDTOFromJSONTyped(json, false);
}

export function SurveyFiltersTagResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyFiltersTagResponseDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'value': json['value'],
    };
}

export function SurveyFiltersTagResponseDTOToJSON(value?: SurveyFiltersTagResponseDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

